import { TYPESFORMAT } from 'core/variables/typesFormat';

const officeCatalogExtensions = TYPESFORMAT.find((type) => type.guid === 'CTTY_12')?.formats.map((format) => format.format) ?? [];

// OpenDocument no está en CTTY_12; Lemonade pide solo 9 porque su `accept` no admite más.
export const OFFICE_CONVERSION_EXTENSIONS: readonly string[] = Array.from(new Set([...officeCatalogExtensions, 'odt', 'ods', 'odp']));

export function getFileExtension(fileName: string | null | undefined): string {
  const name = (fileName ?? '').trimEnd();
  const dotIndex = name.lastIndexOf('.');
  if (dotIndex === -1) return '';
  return name.slice(dotIndex + 1).toLowerCase();
}

// Por extensión y no por MIME: el navegador reporta `application/octet-stream` o vacío en varios formatos Office.
export function isOfficeFileName(fileName: string | null | undefined): boolean {
  return OFFICE_CONVERSION_EXTENSIONS.includes(getFileExtension(fileName));
}

// `"`, CR y LF: el navegador los escapa en el filename del multipart y no en `path`; `%`, `\`, `/` y blancos finales: contrato de files-storage (LUC-408).
export function getOfficeUploadFileName(fileName: string): string {
  return fileName.trimEnd().replaceAll(/["\r\n%\\/]/g, '_');
}

export function appendUploadFile(formData: FormData, file: Blob | File, fileName: string | undefined): void {
  if (!fileName || !isOfficeFileName(fileName)) {
    formData.append('file', file, fileName);
    return;
  }

  const uploadName = getOfficeUploadFileName(fileName);
  formData.append('file', file, uploadName);
  formData.append('convert_to', 'pdf');
  formData.append('path', uploadName);
}
